module.exports = __webpack_public_path__ + "static/media/netcat-logo.ce444807.png";